var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { addLanguage, setMarketplace } from './actions';
import { getLanguageFromRequest, getMarketplaceFromRequest } from '../detectors';
import { createLogger } from '@rakutenfrance/logger';
const logger = createLogger('tolgee-provider');
export const initialAction = (watchContext) => (dispatch) => __awaiter(void 0, void 0, void 0, function* () {
    let language;
    let marketplace;
    if (typeof window === 'undefined') {
        // serverside
        language = getLanguageFromRequest(watchContext.req);
        marketplace = getMarketplaceFromRequest(watchContext.req);
        logger.debug('tolgee initialAction', language, marketplace);
        dispatch(addLanguage(language));
        dispatch(setMarketplace(marketplace));
    }
});
